if (!customElements.get('rare-hero')) {
  customElements.define(
    'rare-hero',
    class RareHero extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-rare-slide]')];
        this.dots = [...this.querySelectorAll('[data-rare-dot]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        this.querySelector('[data-rare-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-rare-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index) {
        if (this.slides.length < 2) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === this.index ? 'true' : 'false');
        });
        this.start();
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const delay = Number(this.dataset.interval || 6) * 1000;
        this.timer = window.setInterval(() => this.show(this.index + 1), delay);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    }
  );
}
